import { useState, useRef, useEffect, useMemo } from "react";
import { textFormatter } from "../../../../../utils/formatter/formatter";

export function BrandMultiSelect({ actions, ctx }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const didInit = useRef(false);

  const { onChange } = actions || {};
  const { selected, options } = ctx || {};

  useEffect(() => {
    function handleClick(event) {
      if (ref.current && !ref.current.contains(event.target)) setOpen(false);
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  useEffect(() => {
    if (!didInit.current && options.length > 0 && selected.length === 0) {
      onChange(options);
      didInit.current = true;
    }
  }, [options, selected, onChange]);

  const allSelected = selected.length === options.length;

  const label = useMemo(() => {
    if (allSelected) return "Todas as marcas";
    if (selected.length === 1) return textFormatter(selected[0], { textTransform: 'uppercase' });
    if (selected.length === 0) return "Nenhuma marca";
    return `${selected.length} marcas`;
  }, [selected, allSelected]);

  const toggle = (opt) => {
    if (allSelected) {
      onChange([opt]);
      return;
    }
    if (selected.includes(opt)) onChange(selected.filter(s => s !== opt));
    else onChange([...selected, opt]);
  };

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button onClick={() => setOpen(p => !p)} style={{
        width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between",
        gap: 8, padding: "6px 12px", border: "1px solid #ddd", borderRadius: "8px",
        background: "#fff", cursor: "pointer", fontSize: "13px",
        color: "#444", fontWeight: "400", outline: "none", whiteSpace: "nowrap",
      }}>
        <span>{label}</span>
      </button>

      {open && (
        <div style={{
          position: "fixed", backgroundColor: "#fff", border: "1px solid #e0e0e0",
          borderRadius: "10px", boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
          zIndex: 9999, height: '28%', overflowY: "auto",
        }}
          ref={el => {
            if (el && ref.current) {
              const btn = ref.current.querySelector("button");
              if (btn) {
                const r = btn.getBoundingClientRect();
                el.style.top = (r.bottom + 4) + "px";
                el.style.left = r.left + "px";
              }
            }
          }}
        >
          <button onClick={() => { 
            onChange(allSelected ? [] : options); 
            setOpen(false); 
          }} style={{
            width: "100%", display: "flex", alignItems: "center", gap: 10,
            padding: "9px 14px", background: "none",
            border: "none", cursor: "pointer", fontSize: "13px",
            color: allSelected ? "#E8773A" : "#333",
            fontWeight: allSelected ? "700" : "400",
            textAlign: "center", borderBottom: "1px solid #f5f5f5",
          }}>
            Todas as marcas
          </button>

          {options.map((opt, index) => {
            const isActive = !allSelected && selected.includes(opt);
            return (
              <button key={opt} onClick={() => toggle(opt)} style={{
                width: "100%", display: "flex", alignItems: "center", gap: 10,
                padding: "9px 14px",
                background: "none",
                border: "none", cursor: "pointer", fontSize: "13px",
                color: isActive ? "#E8773A" : "#333",
                fontWeight: isActive ? "700" : "400", textAlign: "left",
                borderBottom: index < options.length - 1 ? "1px solid #f5f5f5" : "none",
              }}>
                <span style={{
                  width: 16, height: 16, borderRadius: "50%",
                  border: `2px solid ${isActive ? "#E8773A" : "#d0d0d0"}`,
                  display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                  backgroundColor: "transparent",
                }}>
                  {isActive && <span style={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: "#E8773A" }} />}
                </span>
                {textFormatter(opt, { textTransform: 'uppercase' })}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}